import $ from "jquery";
import Swiper from "swiper";

const planRiders = {
  init: function () {
    $(".plan-riders").each(function () {
      const $section   = $(this);
      const swiperEl   = $section.find(".plan-riders__swiper-container").get(0);
      const $prevBtn   = $section.find(".plan-riders__nav-prev");
      const $nextBtn   = $section.find(".plan-riders__nav-next");
      const $current   = $section.find(".plan-riders__nav-current");
      const $total     = $section.find(".plan-riders__nav-total");

      if (!swiperEl) {return;}

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1.1,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 42,
          },
        },
        on: {
          init: function () {
            planRiders.updateCounter(this, $current, $total);
            planRiders.updateNavState(this, $prevBtn, $nextBtn);
          },
          slideChange: function () {
            planRiders.updateCounter(this, $current, $total);
            planRiders.updateNavState(this, $prevBtn, $nextBtn);
          },
        },
      });

      swiperEl._swiper = swiper;

      $prevBtn.on("click", function () { swiper.slidePrev(); });
      $nextBtn.on("click", function () { swiper.slideNext(); });

      // Recalculate after layout settles to fix incorrect slide width on init
      setTimeout(function () {
        swiper.update();
        planRiders.updateCounter(swiper, $current, $total);
        planRiders.updateNavState(swiper, $prevBtn, $nextBtn);
      }, 100);
    });
  },

  updateCounter: function (swiper, $current, $total) {
    const activeIndex  = swiper.activeIndex + 1;
    const slidesCount  = swiper.slides ? swiper.slides.length : 0;
    $current.text(activeIndex);
    $total.text(slidesCount);
  },

  updateNavState: function (swiper, $prevBtn, $nextBtn) {
    $prevBtn.prop("disabled", swiper.isBeginning);
    $nextBtn.prop("disabled", swiper.isEnd);
  },
};

$(document).ready(function () {
  if ($(".plan-riders").length > 0) {
    planRiders.init();
  }
});
